var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null),
  settings = require( "../../src/js/lib/settings" );

function LocalSubNav(el) {
  this.el = el;
  this.$el = $(el);


  $(window).on('scroll', function() {
    var scroll = $(window).scrollTop(),
        headerHeight = $('.header').outerHeight();

    if( scroll > headerHeight ) {
      $('body').addClass('js-local-subnav-active');
    } else {
      $('body').removeClass('js-local-subnav-active');
    }
  });

  $('.local-subnav__button-top').click(function() {
    $('html, body').animate({ scrollTop: 0 }, 'slow', function() {
      $('#main-content-anchor').focus(); 
    });
    return false;
  });

}

module.exports = LocalSubNav;
